import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { If } from 'utils';
import { UiKit } from 'components';
import { ReactComponent as LockIcon } from 'assets/img/icons/lock-fill.svg';

export default function LockContainer({
  locked = false,
  children = null,
  tooltipText = 'This is a global-level configuration, please select Global Settings from the dropdown above.'
}) {
  return (
    <UiKit.Tooltip disabled={!locked}>
      <UiKit.Tooltip.Trigger
        className={cn(styles.container, { [styles.locked]: locked })}
      >
        <div className={styles.content}>
          <If test={locked}>
            <LockIcon className={styles.lockIcon} />
          </If>
          {children}
        </div>
      </UiKit.Tooltip.Trigger>
      <UiKit.Tooltip.Content offset="0,10">{tooltipText}</UiKit.Tooltip.Content>
    </UiKit.Tooltip>
  );
}
